export default __webpack_public_path__ + "assets/ad103103051f65d06d02895685d8eadf.png";